import React, { useReducer } from 'react'
import { pointrThemedNavbarState } from './store/State'
import pointrThemedNavbarReducer from './store/Reducer'
import PointrThemedNavbarService from './Service'

const pointrThemedNavBarContext = {
  state: pointrThemedNavbarState,
  handlers: {
    onSetMenuAnchor: (_anchor: any) => {},
    setUserActionMenuAnchor: (_anchor: any) => {}
  }
}

export type PointrThemedNavBarContext = typeof pointrThemedNavBarContext

export const PointrThemedNavBarContextProvider = React.createContext<PointrThemedNavBarContext>(
  pointrThemedNavBarContext
)

const PointrThemedNavBarProvider: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer(pointrThemedNavbarReducer, pointrThemedNavbarState)

  const handlers = {
    onSetMenuAnchor: PointrThemedNavbarService.setMenuAnchor(state, dispatch),
    setUserActionMenuAnchor: PointrThemedNavbarService.setUserActionMenuAnchor(state, dispatch)
  }

  const contextValues = {
    ...pointrThemedNavBarContext,
    state,
    handlers
  }

  return (
    <PointrThemedNavBarContextProvider.Provider value={contextValues}>
      {children}
    </PointrThemedNavBarContextProvider.Provider>
  )
}

export default PointrThemedNavBarProvider
